module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dba629c24296756d68a135988fe96011.svg";